import api from './api';

/**
 * Patient-facing kit results (token-authenticated), plus an admin helper to
 * mint the shareable link.
 */
export const PatientResultsService = {
  // Public: fetch results for a token.
  async getResults(token) {
    return api.get(`/patient-results/${token}`);
  },

  // Admin: create/return a shareable results link for a patient.
  async generateLink(patientId) {
    return api.post('/patient-results/generate', { patientId });
  },

  // Admin: email the patient their results link.
  async emailResults(patientId) {
    return api.post('/patient-results/email', { patientId });
  },

  // Admin: a member's lab reports + Deployed Hearts account status.
  async getMemberResults(patientId) {
    return api.get(`/patient-results/member/${encodeURIComponent(patientId)}`);
  },

  // Admin: short-lived, read-only link to view Deployed Hearts as the member.
  async impersonateMember(patientId) {
    return api.post(`/patient-results/member/${encodeURIComponent(patientId)}/impersonate`);
  },
};

export default PatientResultsService;
